import script from "./DekDwiManik.vue?vue&type=script&setup=true&lang=js"
export * from "./DekDwiManik.vue?vue&type=script&setup=true&lang=js"

import "./DekDwiManik.vue?vue&type=style&index=0&id=364796e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-364796e7"]])

export default __exports__